class t extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
export {
  t as NetworkError
};
